module.exports = __webpack_public_path__ + "assets/img/3c79a81951876009c590e94c49ad383a.png";